import React, {useState} from "react";
import axios from "axios";
import { Box, Button, Column, Columns, Control, Field, Pagination, Table } from "@allxsmith/bestax-bulma";
import {useContactsData} from "../../hooks/useContactsData";
import {useSelector} from "react-redux";
import {getContactsData} from "../../state/selectors";
import SearchBar from "../Utils/SearchBar";
import useSelect from "../../hooks/useSelect";
import {getPhoneNumber} from "../../utils";
import Nav from "../Nav/Nav";
import LoadingSpinner from "../Utils/Spinner";
import {useSearchParams} from "react-router-dom";
import PaginationWrapper from "../Utils/PaginationWrapper";

function Contacts({history, endpoint, location}) {
  const [page, setPage] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();

  const [searchText, setSearchText] = useState();
  const [currentSearch, setCurrentSearch] = useState();
  const [searchFresh, setSearchFresh] = useState(1);

  const types = {
    CC: "Customer",
    SP: "Supplier"
  };

  const [deactive, deactiveInput] = useSelect({
    label: "Show Deactivated",
    initialValue: "NO",
    options: [
        {name:"No", value: "NO"},
        {name:"Yes", value:"YES"}
    ]
  });


  let view;
  let viewName = "Contacts";
  let newContactUrl = "/editcontact"

  const queryParams = searchParams.get("type")
  let params = {page};

  const [typeView, typeViewInput] = useSelect({
    label: "Type",
    initialValue: queryParams ? queryParams : "ALL",
    options: [
      {name: "ALL", value: "ALL"},
      {name: "Customer", value: "CC"},
      {name: "Supplier", value: "SP"}
    ]
  });

  const [onlyView, onlyViewInput] = useSelect({
    label: "Show Only",
    initialValue: "NONE",
    options: [
      {name: "", value: "NONE"},
      {name: "Partial Contacts", value: "pc"},
      {name: "Missing Account Forms", value: "maf"}
    ]
  });

  // if (queryParams.type) {
  //   view = queryParams.type;
  //   params.contact_type = view;
  //   newContactUrl += "?type=" + view;
  //   viewName = types[view] + "s";
  // }
  if(typeView !== "ALL"){
    view = typeView;
    params.contact_type = typeView;
    newContactUrl += "?type=" + view;
    viewName = types[view] + "s";
  }
  if(onlyView){
    params.only_view=onlyView
  }
  if (currentSearch) {
    params.search = currentSearch;
  }
  if (deactive === "YES"){
    params.show_deactive="true"
  }
  if (searchFresh){
    params.searchFresh = searchFresh;
  }
  const complete = useContactsData(params);
  const data = useSelector(getContactsData);

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh + 1);
  };

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  if (!complete) {
    return (
        <div>
          <Nav/>
          <LoadingSpinner/>
        </div>
    );
  }

  document.title = viewName;

  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <div>
      <Nav/>
      <br/>
      <br/>
      <Box>
        <Columns isMultiline>
          <Column>
            <label className="label">Search</label>
            <SearchBar
              handleSearch={handleSearch}
              setSearchText={setSearchText}
              searchText={searchText}
              clear={clear}
            />
          </Column>
          {deactiveInput}
          {onlyViewInput}
          {typeViewInput}
          <Column>
            <Field>
              <Control>
                <Button
                  onClick={() => window.open(newContactUrl, "_self")}
                  color="success"
                  className="is-pulled-right"
                >
                  New {view ? types[view] : "Contact" } +
                </Button>
              </Control>
            </Field>
          </Column>
        </Columns>
      </Box>
      <Box>
        <h1 className="title">{viewName}</h1>
        <Table className="is-hoverable" isFullwidth>
          <thead>
          <tr>
            <th>ID</th>
            <th>Type</th>
            <th>Display Name</th>
            <th>Contact Number</th>
            <th>Email</th>
            <th>Address</th>
          </tr>
          </thead>
          <tbody>{data.results.map((value, index) => (
            <tr
              className="clickable"
              onClick={() => window.open(`/editcontact/${value.id}`, "_self")}
              key={value.id ?? index}
            >
              <td>{value.id}</td>
              <td>{types[value.contact_type]} </td>
              <td>{value.display_name}</td>
              <td>{getPhoneNumber(value)}</td>
              <td>{value.email}</td>
              <td onClick={(e) => e.stopPropagation()}>
          <pre>
            {`${value.address_line1}\n ${value.town} \n ${value.postcode}`}{" "}
          </pre>
              </td>
            </tr>
          ))}</tbody>
        </Table>
        <PaginationWrapper
          setPage={setPage}
          page={page}
          dataCount={Math.ceil(data.count / 25)}
        />
      </Box>
    </div>
  );
}

export default Contacts;
